/**
 * Key codes used by components.
 */
export const KeyCode = {
  ENTER: 13
};